import { useTranslation } from 'react-i18next';
import { AmountUtils, cn, PaletteUtils } from '@shared/utils';
import { InquiryStatus, type GetInquiryResponse } from '@shared/api';
import { NoData, Text } from '@shared/widgets';

interface TotalCostProps {
  className?: string;
  inquiry: GetInquiryResponse;
}

export const TotalCost = (props: TotalCostProps) => {
  const { t } = useTranslation('travel');

  const noDataText = {
    [InquiryStatus.InProgress]: t('totalCost.noData.inProgress'),
    [InquiryStatus.Cancelled]: t('totalCost.noData.cancelled'),
  };
  return (
    <section
      className={cn(
        'flex h-fit flex-col gap-6 bg-white p-6 dark:bg-soft-black',
        PaletteUtils.isVcfcPalette && 'rounded-xl dark:border dark:border-gray-black',
        props.className,
      )}
    >
      <Text tag='h2' weight='semibold' size='2xl'>
        {t('totalCost.title')}
      </Text>
      {props.inquiry.status === InquiryStatus.Confirmed || props.inquiry.status === InquiryStatus.Completed ? (
        <Text tag='h3' weight='semibold' size='4xl'>
          {AmountUtils.transformToAmountWithCurrency(props.inquiry.totalCost, props.inquiry.currency)}
        </Text>
      ) : (
        <NoData className='justify-start p-0' color='gray' text={noDataText[props.inquiry.status]} />
      )}
    </section>
  );
};
